import { FilterType } from '../enums/filter-type';

export interface IGetFacetsRequest {
	[FilterType.PRESELECTED_FILTER_TYPE]: FilterType|undefined;
	[FilterType.PRESELECTED_FILTER_VALUES]: string[]|undefined;
	[FilterType.REQUESTED_FILTERS]: FilterType[];
	[FilterType.BASE_RANKING_ID]: number;
	[FilterType.YEAR]: number | "latest";
	[FilterType.DISCIPLINE]: number|null|undefined;
}
